import z from "zod";

import { ErrorClassification } from "../../../sentry/classification";
import type { ErrorDetails } from "../domain";

const areaCodeErrorTypeValues = ["UNKNOWN", "AREA_CODE_LOOKUP_FAILED"] as const;
const areaCodeErrorTypeSchema = z.enum(areaCodeErrorTypeValues);
const AreaCodeErrorType = areaCodeErrorTypeSchema.enum;
type AreaCodeErrorType = z.infer<typeof areaCodeErrorTypeSchema>;

export type AreaCodeErrors =
  | { errorType: typeof AreaCodeErrorType.UNKNOWN; data: undefined }
  | {
      errorType: typeof AreaCodeErrorType.AREA_CODE_LOOKUP_FAILED;
      data: {
        latitude: number;
        longitude: number;
        radiusKm: number;
        error?: string;
      };
    };

export const areaCodeErrorDetails: Record<AreaCodeErrorType, ErrorDetails> = {
  UNKNOWN: { classification: ErrorClassification.UNEXPECTED_ERROR, sentryDescription: "Unknown Error" },
  AREA_CODE_LOOKUP_FAILED: {
    classification: ErrorClassification.UNEXPECTED_ERROR,
    sentryDescription: "Failed to lookup area codes for coordinates",
  },
};
